import './jquery'
import I18n from './i18n'

function visibleInputsAreValid(visibleInputs) {
  let enableButton = true
  visibleInputs.each((index, element) => {
    if (!element.checkValidity()) {
      enableButton = false
      return false
    }
    return true
  })
  return enableButton
}

export function checkEnableButton(visibleInputs, buttonToCheck) {
  if (visibleInputsAreValid(visibleInputs)) {
    if (buttonToCheck.hasClass('disabled')) {
      buttonToCheck.removeClass('disabled')
      buttonToCheck.attr('disabled', false)
    }
  } else if (!buttonToCheck.hasClass('disabled')) {
    buttonToCheck.addClass('disabled')
    buttonToCheck.attr('disabled', true)
  }
}

export function checkPasswordsMatch(passwordField, confirmationField) {
  const password = passwordField.val()
  const confirmPassword = confirmationField.val()
  if (password.length < 1 || confirmPassword.length < 1) {
    return
  }

  if (password !== confirmPassword) {
    confirmationField.get(0).setCustomValidity(I18n.t('password_confirmation_error'))
  } else {
    confirmationField.get(0).setCustomValidity('')
  }
}

export function checkEmailMatch(emailField) {
  const email = emailField.val()
  const regExp = new RegExp(I18n.t('js_email_regex'), 'i')
  if (regExp.test(email)) {
    emailField.get(0).setCustomValidity('')
  } else {
    emailField.get(0).setCustomValidity(I18n.t('email_error'))
  }
}

/**
 * touched = user has entered that field already
 */
export function addTouchedEventListener(elements) {
  elements.on('blur keydown', function () {
    $(this).addClass('touched')
  })
}
